import { render, staticRenderFns } from "./FormPokemon.vue?vue&type=template&id=78f4b968&scoped=true"
import script from "./FormPokemon.vue?vue&type=script&lang=js"
export * from "./FormPokemon.vue?vue&type=script&lang=js"
import style0 from "./FormPokemon.vue?vue&type=style&index=0&id=78f4b968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4b968",
  null
  
)

export default component.exports